import CONTENT_TYPE_MAP from './../../contentTypeMap';

export default {
  name: 'page',
  uniqKey: '_id',
  crudMapping: {
    // create: 'createPage',
    readMany: 'pages',
    readOne: 'page',
    update: 'updatePage',
  },
  readManySchema: {
    jsonSchema: {
      type: 'object',
      properties: {
        title: {
          type: 'string',
        },
      },
    },
  },
  defaultSchema: {
    jsonSchema: {
      title: 'Page',
      type: 'object',
      required: [
        'title',
        'pageTitle',
        'pageDescription',
        // 'fields',
      ],
      properties: {
        title: {
          type: 'string',
        },
        pageTitle: {
          type: 'string',
          title: 'Page Title',
        },
        pageDescription: {
          type: 'string',
          title: 'Page Description',
        },
        image: {
          type: 'string',
          title: 'Representative Image',
        },
        fields: {
          type: 'array',
          title: 'Fields',
          default: [],
          items: {
            type: 'object',
            properties: {
              field: {
                type: 'string',
              },
              content: {
                type: 'string',
              },
              contentType: {
                type: 'string',
                enum: Object.keys(CONTENT_TYPE_MAP),
                enumNames: Object.values(CONTENT_TYPE_MAP),
                default: 'string',
              },
            },
          },
        },
        richFields: {
          type: 'array',
          title: 'Rich Fields',
          default: [],
          items: {
            type: 'object',
            properties: {
              field: {
                type: 'string',
              },
              content: {
                type: 'string',
              },
              contentType: {
                type: 'string',
                enum: Object.keys(CONTENT_TYPE_MAP),
                enumNames: Object.values(CONTENT_TYPE_MAP),
                default: 'string',
              },
            },
          },
        },
        groupFields: {
          type: 'array',
          title: 'Group Fields',
          items: {
            type: 'object',
            required: ['name'],
            properties: {
              name: {
                title: 'Name',
                type: 'string',
              },
              description: {
                title: 'Description',
                type: 'string',
              },
              companyIds: {
                type: 'array',
                title: 'Companies',
                items: {
                  type: 'string',
                },
              },
            },
          },
        },
      },
    },
    uiSchema: {
      title: {
        'ui:disabled': true,
      },
      image: {
        'ui:widget': 'imageWidget',
        'ui:description': 'This image will be used when shared on social.',
      },
      fields: {
        items: {
          field: {
            'ui:disabled': true,
          },
          content: {
            'ui:widget': 'textarea',
          },
          contentType: {
            'ui:disabled': true,
          },
        },
      },
      richFields: {
        items: {
          field: {
            'ui:disabled': true,
          },
          content: {
            'ui:widget': 'wysiwygWidget',
            'ui:options': {
              wysiwygConfig: {
                toolbar: {
                  options: ['link', 'list', 'inline', 'textAlign'],
                  link: {
                    showOpenOptionOnHover: false,
                  },
                  list: {
                    options: ['unordered'],
                  },
                  inline: {
                    inDropdown: false,
                    options: ['bold', 'italic'],
                  },
                  textAlign: {
                    inDropdown: false,
                    options: ['left', 'center', 'right', 'justify'],
                  },
                },
                editorClassName: 'form-control',
              },
              blockType: 'unordered-list-item',
            },
          },
          contentType: {
            'ui:disabled': true,
          },
        },
      },
      groupFields: {
        items: {
          companyIds: {
            'ui:field': 'hasManyField',
            'ui:options': {
              sortable: true,
            },
          },
        },
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/schemas/admin/page.js